<template>
  <router-view />
</template>

<style lang="scss">
html {
  overflow-y: scroll;
  margin-bottom: 1px;
  height: 100%;
}
body,
#app,
#app > div {
  height: 100%;
}
body {
  background-color: $body-background-color;
}
input,
select,
textarea {
  border-radius: 3px !important;
}
</style>
